const CommentsThread = {
	comments: 'Comments'
}

export default CommentsThread;